import { connect } from 'react-redux'
import { formValueSelector } from 'redux-form'
import flowRight from 'lodash/flowRight'
import withConstantPermissions from 'shared/containers/withConstantPermissions'
import { accountsNames } from '../constants'
import { FORM_NAME } from './constants'
import { accountViewBalance } from 'src/store/account'

export default flowRight(
  withConstantPermissions(['ACC_ACCOUNT_OPEN as AddAccount']),
  connect(
    (state) => ({
      selectedCCY: formValueSelector(FORM_NAME)(state, 'CCY'),
    }),
    (dispatch, ownProps) => ({
      handleCCYChange: (ccy) => {
        const { change, CashAccounts, clearFields } = ownProps
        const accountType = ownProps.cashOut ? 'credit' : 'debit'
        const accountTypeToClear = ownProps.cashOut ? 'debit' : 'credit'
        const filteredAccounts = CashAccounts.filter((account) => account.CCY === ccy)

        if (filteredAccounts.length) {
          const account = filteredAccounts[0]

          const accountsData = {
            accNo: account.AccNo,
            chosenAccNo: account.AccNo,
            accID: account.AccountID,
            accHash: account.HashSum_AccountID_,
            accTitle: account.TitleUNI,
          }

          Object.keys(accountsData).forEach((key) => change(accountsNames[accountType][key], accountsData[key]))

          const { AccountID, HashSum_AccountID_ } = account
          Promise.resolve(
            dispatch(
              accountViewBalance({
                AccountID,
                HashSum_AccountID_,
              }),
            ),
          )
            .then(({ payload: { Balance } }) => change(accountsNames[accountType].accBalance, Balance))
            .catch((error) => console.log(error))
        } else {
          clearFields(
            false,
            false,
            ...Object.keys(accountsNames[accountType]).map((key) => accountsNames[accountType][key]),
          )

          change('CreditAccNo', '')
          change('DebitChosenAccNo', '')
          change('CreditChosenAccNo', '')
          change('DebitAccNo', '')
          change('DebitAccID', '')
          change('CreditTitleUNI', '')
          change('DebitTitleUNI', '')
          change('CreditAccID', '')
          change('CreditAccBalance', 0)
          change('DebitAccBalance', 0)
        }

        clearFields(
          false,
          false,
          ...Object.keys(accountsNames[accountTypeToClear]).map((key) => accountsNames[accountTypeToClear][key]),
        )
      },
    }),
  ),
)
